// extracted by mini-css-extract-plugin
export default {"containerOrigem":"Origem_containerOrigem__haAFq"};